import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

export default function Navbar() {
  const [hoveredPath, setHoveredPath] = useState("");

  const baseLinkStyle = {
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "500",
  };

  const getLinkStyle = ({ isActive }, path) => ({
    ...baseLinkStyle,
    color:
      isActive || hoveredPath === path ? "var(--primary)" : "var(--gray5)",
  });

  return (
    <nav
      className="site-navbar"
      style={{
        display: "flex",
        gap: "32px",
        alignItems: "center",
      }}
    >
      <NavLink
        to="/"
        style={(state) => getLinkStyle(state, "/")}
        onMouseEnter={() => setHoveredPath("/")}
        onMouseLeave={() => setHoveredPath("")}
        end
      >
        Home
        <FontAwesomeIcon icon={faAngleDown} />
      </NavLink>
      <NavLink
        to="/shop"
        style={(state) => getLinkStyle(state, "/shop")}
        onMouseEnter={() => setHoveredPath("/shop")}
        onMouseLeave={() => setHoveredPath("")}
      >
        Shop
        <FontAwesomeIcon icon={faAngleDown} />
      </NavLink>
      <NavLink
        to="/pages"
        style={(state) => getLinkStyle(state, "/pages")}
        onMouseEnter={() => setHoveredPath("/pages")}
        onMouseLeave={() => setHoveredPath("")}
      >
        Pages
        <FontAwesomeIcon icon={faAngleDown} />
      </NavLink>
      <NavLink
        to="/blog"
        style={(state) => getLinkStyle(state, "/blog")}
        onMouseEnter={() => setHoveredPath("/blog")}
        onMouseLeave={() => setHoveredPath("")}
      >
        Blog
        <FontAwesomeIcon icon={faAngleDown} />
      </NavLink>
      <NavLink
        to="/about"
        style={(state) => getLinkStyle(state, "/about")}
        onMouseEnter={() => setHoveredPath("/about")}
        onMouseLeave={() => setHoveredPath("")}
      >
        About Us
      </NavLink>
      <NavLink
        to="/todo"
        style={(state) => getLinkStyle(state, "/todo")}
        onMouseEnter={() => setHoveredPath("/todo")}
        onMouseLeave={() => setHoveredPath("")}
      >
        To-Do List
      </NavLink>
      <NavLink
        to="/contact"
        style={(state) => getLinkStyle(state, "/contact")}
        onMouseEnter={() => setHoveredPath("/contact")}
        onMouseLeave={() => setHoveredPath("")}
      >
        Contact Us
      </NavLink>
    </nav>
  );
}
